/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import AddedBy from './AddedBy/index'
import ExternalMappingsCount from './ExternalMappingsCount/index'
import LocationCount from './LocationCount/index'
import Problem from './Problem/index'
import ProviderCount from './ProviderCount/index'
import React from 'react'
import ReconnectAction from './ReconnectAction/index'
import Status from './Status/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content"
  
}) {
let connectionDisplayNameValueData = fromData.useDataValue({ viewPath,
context: 'connection',
path: 'display_name',
})
let connectionUserVaxiomPersonValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
path: 'user.vaxiom_person',
format: fromFormat.patientName,
})
let aggregateData = fromAggregate.any(connectionDisplayNameValueData, connectionUserVaxiomPersonValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="connection.display_name"
 data="connection.user.vaxiom_person"
 format="/Data/format.js patientName"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<AddedBy
  viewPath={`${viewPath}/AddedBy`}
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
<ReconnectAction
  viewPath={`${viewPath}/ReconnectAction`}
/>
</div>
<Problem
  viewPath={`${viewPath}/Problem`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<ProviderCount
  viewPath={`${viewPath}/ProviderCount`}
/>
<LocationCount
  viewPath={`${viewPath}/LocationCount`}
/>
<ExternalMappingsCount
  viewPath={`${viewPath}/ExternalMappingsCount`}
/>
</div>
</div>
{children}
</React.Fragment>)
}